import { useState, useEffect, Fragment } from 'react';

import { SegmentControlV2 } from '@zola/zola-ui/src/components/SegmentControlV2';

import { useFormState, useForm } from 'react-final-form';

import { getYears } from '~/components/common/form/dates';
import { FlexibleDateSelection } from '~/components/common/form/FlexibleDateSelection/FlexibleDateSelection';
import { FormWithMutators } from '~/components/common/form/formWithMutators';
import { WeddingDateFormFields } from '~/components/common/form/WeddingDateField/types';

import { destringifyYear } from '../FlexibleDateSelection/flexibleDateSelectionHelpers';
import { RankedDateSelection } from '../RankedDateSelection/RankedDateSelection';

import styles from './expandedDateFields.module.less';

const FLEXIBLE_KEY = 'FLEXIBLE_KEY';
const CHOOSE_DATES_KEY = 'CHOOSE_DATES';

export const ExpandedDateFields = ({
  forceErrorsVisible = false,
}: {
  forceErrorsVisible?: boolean;
}) => {
  const { values } = useFormState<WeddingDateFormFields>();
  const form = useForm<WeddingDateFormFields>() as FormWithMutators<WeddingDateFormFields>;

  const { showFlexibleDateSelection } = values;
  const { setField: setFormField } = form.mutators;

  const onSegmentClick = (key: string) => {
    setFormField('showFlexibleDateSelection', key === FLEXIBLE_KEY);
  };

  const years = getYears(3).map((year) => year.label);

  const [yearsToShow, setYearsToShow] = useState<string[]>([]);

  useEffect(() => {
    const selectedYears = values.expandedWeddingYears
      ? values.expandedWeddingYears.map((year) => {
          return destringifyYear(year);
        })
      : [];

    setYearsToShow(selectedYears);
  }, [values.expandedWeddingYears]);

  return (
    <Fragment>
      <SegmentControlV2
        segments={[
          {
            key: FLEXIBLE_KEY,
            text: 'No date yet',
          },
          {
            key: CHOOSE_DATES_KEY,
            text: 'We have a date',
          },
        ]}
        onClick={onSegmentClick}
        className={styles.segmentControl}
        activeSegment={showFlexibleDateSelection ? 0 : 1}
      />

      {showFlexibleDateSelection ? (
        <FlexibleDateSelection
          years={years}
          yearsToShow={yearsToShow}
          setYearsToShow={setYearsToShow}
        />
      ) : (
        <RankedDateSelection forceErrorsVisible={forceErrorsVisible} />
      )}
    </Fragment>
  );
};
